"use strict";

import SelectorPage from './SelectorPage';

export default class CartPage extends SelectorPage {
	constructor() 
	{
		super();
	}
}
